import CompaniesPage from "../components/pages/companies/CompaniesPage";
import CompanyCreatePage from "../components/pages/companies/CreateCompanyPage";
import KycPolicyPage from "../components/pages/companies/KycPolicyPage";

const routes = [
    {
        path: "/companies",
        element: <CompaniesPage />
    },
    {
        path: "/companies/create",
        element: <CompanyCreatePage />
    },
    {
        path: "/companies/edit/:companyID",
        element: <CompanyCreatePage />
    },
    {
        path: "/companies/kyc-policy",
        element: <KycPolicyPage />
    }
];

export default routes;
